function SearchArea(props: any) {
  let myProps = {
    list: (inData: any) => { },
    listOpt: {},
    setListOpt: (inData: any) => { },
    ...props
  };

  const handleSearch = (inData: any) => {
    let value = inData.target.value;
    let name = inData.target.name;
    let change_list_opt: any = {};
    change_list_opt[name] = value;
    myProps.list(change_list_opt);
  };

  return (
    <div className="my_flex_center">
      <select className="search-input"
        value={myProps.listOpt.s_word_type} name="s_word_type" onChange={handleSearch} >
        <option value="">전체유형</option>
        <option value="word">단어</option>
        <option value="stc">문장</option>
      </select>
      <input type="text" className="search-input"
        value={myProps.listOpt.s_title_like} name="s_title_like"
        onChange={handleSearch} autoComplete="off" />
      <button className="btn btn-dark" onClick={() => { myProps.list({}); }}>검색</button>
    </div>
  );
};
export default SearchArea;